import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BsModalService, ModalModule, BsDatepickerModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { DateTimePickerModule } from 'ng-pick-datetime';

import { ChartsModule } from 'ng2-charts';
import { BrandComparisonReportService } from './brand-comparison-reports.service';
import { CommonModule } from '@angular/common';
import { Daterangepicker } from 'ng2-daterangepicker';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { SharedModule } from 'app/_shared/shared.module';
import { ReportsComponentModule } from 'app/views/reports-component/reports-component.module';
import { CKEditorModule } from 'ng2-ckeditor';
import { BrandComparisonReportsComponent } from './brand-comparison-reports.component';

const routes: Routes = [
  {
    path: '',
    component: BrandComparisonReportsComponent,
    data: {
      title: 'So sánh thương hiệu'
    },
  }
];
@NgModule({
  imports: [
    ChartsModule,
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsComponentModule,
    CKEditorModule
  ],
  declarations: [BrandComparisonReportsComponent],
  providers: [BrandComparisonReportService]
})
export class BrandComparisonReportsModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/brand-comparison/brand-comparison-reports.module.ts